import { formatDate } from '@frontend/date';

export const getTimestampForProviderSignature = () => formatDate(new Date(), 'MMMM D, YYYY hh:mm:ss');
